/**
 * @module imageWrapper
 */

module.exports = function() {
    if ( window.innerWidth >= 992 ) {
        document.querySelectorAll( '[class*="wp-image-"]' ).forEach( ( elem ) => {
            // Skip if already wrapped
            if ( elem.parentElement && elem.parentElement.classList.contains( 'wrap-block' ) ) {
                return;
            }

            const wrap = document.createElement( 'span' );
            wrap.classList.add( 'wrap-block' );
            elem.parentElement.insertBefore( wrap, elem );
            wrap.appendChild( elem );
        } );
    }
}; // exports
